/**
 * "Permisos de la columna": quién escribe sus valores.
 * Ver extras_mg/api/campos/views.py.
 */
export default (client) => ({
  obtener(campoId) {
    return client.get(`/extras-mg/campos/${campoId}/`)
  },
  guardar(campoId, nivel, permitirEnFormularios) {
    return client.put(`/extras-mg/campos/${campoId}/`, {
      nivel,
      permitir_en_formularios: permitirEnFormularios,
    })
  },
})
